import { inject } from '@angular/core';
import { combineLatest, of } from 'rxjs';

import { TiiaAuthService } from '../auth.service';
import { TiiaService } from '../tiia.service';

import type { ResolveFn } from '@angular/router';
import type { Observable } from 'rxjs';

const redirectToRoot = (): Observable<undefined> => {
  globalThis.location.href = '/';

  return of(undefined);
};

const isFailedPaymentState = (paymentState: string): boolean =>
  paymentState === 'ABORTED' || paymentState === 'ERROR';

const resolvePaymentWithoutSession = (
  tiiaß: TiiaService,
  paymentState: string,
): Observable<boolean> => {
  if (isFailedPaymentState(paymentState)) {
    tiiaß.payment$.next(false);
  }

  return of(true);
};

const resolvePaymentWithSession = (
  tiiaß: TiiaService,
  agreementNumber: string,
  paymentState: string,
): Observable<unknown> =>
  paymentState === 'COMPLETED'
    ? tiiaß.fetchDocuments$(agreementNumber)
    : combineLatest([
        tiiaß.fetchDocuments$(agreementNumber),
        tiiaß.fetchPaymentMethods$(),
        tiiaß.startQrPayment$(agreementNumber),
      ]);

const initializePaymentResolution = (
  tiiaß: TiiaService,
  agreementNumber: string,
): void => {
  tiiaß.setLoading$.next('Načítám výsledky platby...');
  tiiaß.setAgreementNumber(agreementNumber);
};

export const resolvePayment$: ResolveFn<Observable<unknown>> = route => {
  const tiiaß = inject(TiiaService);
  const authß = inject(TiiaAuthService);

  const agreementNumber = route.queryParamMap.get('agreementNumber');
  const paymentState = route.queryParamMap.get('paymentState');

  if (!agreementNumber || !paymentState) {
    return redirectToRoot();
  }

  initializePaymentResolution(tiiaß, agreementNumber);

  if (authß.noSession) {
    return resolvePaymentWithoutSession(tiiaß, paymentState);
  }

  return resolvePaymentWithSession(tiiaß, agreementNumber, paymentState);
};
